import { ModalElement } from '../modal/modalElement';
import React, { useContext, useState, useEffect, useRef } from 'react';
import InputGroup from 'react-bootstrap/InputGroup';
import Load from '../../components/load/load';
import { ErrorModal } from '../../components/toast/errorModal';
import {Context} from '../../context/AuthContext';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import './recoverPassword.style.css'

export function RecoverPassword({ isOpen, onClose }) {
    
    const formRecoverPasswordRef = useRef(null);
    const [validated, setValidated] = useState(true);
    const [ email, setEmail ] = useState('');
    const [ emailTouched, setEmailTouched ] = useState(false);
    const { handleRecoverPassword, isFetchingRecoverPassword, createError } = useContext(Context);

    useEffect(() => {
        setValidated(!!email);
    }, [email]);

    const handleSubmit = (event) => {    
        if (!formRecoverPasswordRef.current.checkValidity()) {
            setValidated(true);
            return;
        }
        handleRecoverPassword(email) //in this function will go the logic when the user press the button "ENVIAR" to recover the password
        onClose();
    };

    return (
        <ModalElement
            size='m'
            show={isOpen}
            onHide={() => {
                onClose();
                setValidated(false);
            }}
            id="modal">
                <Form ref={formRecoverPasswordRef} validated={validated} id="form">
                    <Form.Group className="mb-3" controlId="formBasicEmail">
                        <Form.Label>Recuperar senha</Form.Label>
                        <InputGroup hasValidation>
                            <Form.Control required onTouchStart={() => setEmailTouched(true)} onChange={(e) => setEmail(e.target.value)} type="email" isInvalid={emailTouched && !email} placeholder="Email"/>
                            <Form.Control.Feedback type="invalid">
                                É necessário preencher seu email.
                            </Form.Control.Feedback>
                        </InputGroup>
                    </Form.Group>

                    <Button className='button' onClick={(e) => handleSubmit(e)} variant="primary" type="button">
                        {isFetchingRecoverPassword? <Load /> : 'ENVIAR'}
                    </Button>
                    {createError.isError && <ErrorModal text={createError.message} show={true}/>}
                </Form>
                
        </ModalElement>
    );
}